<template>
    <header class="header">
        <h1 class="logo-container">
            <a 
                href="/" 
                class="logo"
            >ma-preadmission.com</a>
        </h1>
    </header>
</template>

<script>
    export default {
        name: 'TheHeader'
    }
</script>

<style lang="scss" scoped>
    @import '@/assets/styles/variables';

    .header {
        background-color: white;
        padding: .75rem 1.5rem;
        box-shadow: 0 0 .5rem rgba(black, .2);
    }
    .logo-container {
        background-color: white;
        width: fit-content;
        margin: 0 auto;
    }
    .logo {
        font-weight: bold;
        display: block;
        font-size: 1.25rem;
        
        &, &:link, &:visited, &:hover {
            color: $color-primary;
            text-decoration: none;
        }

        &::before {
            content: '';
            display: block;
            margin: 0 auto .25rem;
            width: 2rem;
            height: 2rem;
            background: url('../../assets/images/icons/pread.svg') left center / 100% no-repeat ;
        }
    }
</style>